import React, {useCallback} from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from 'react-native';
import {useDispatch} from 'react-redux';
import List from '../List';

const styles = StyleSheet.create({
  main: {},
  container: {},
  clea: {},
  content: {
    backgroundColor: 'white',
    borderRadius: 10,
    marginHorizontal: 20,
  },
});

const Item = ({renderFields, fields, prefix, onPress, columns}) => {
  const Comp = onPress ? TouchableOpacity : View;
  const {width} = useWindowDimensions();
  return (
    <Comp style={{width: (width - 40) / columns}} onPress={onPress}>
      {renderFields(fields, prefix)}
    </Comp>
  );
};

export default function FlatList({
  fieldId,
  value = [],
  item_container_fields,
  emptyState_container,
  header_container,
  footer_container,
  renderFields,
  actionOnPress,
  flat,
  columns,
  variant,
}) {
  const dispatch = useDispatch();

  const onPress = useCallback(
    _id => {
      if (actionOnPress) {
        dispatch({type: actionOnPress, payload: {_id}});
      }
    },
    [actionOnPress, dispatch],
  );

  const renderItem = ({item, index}) => (
    <Item
      fields={item_container_fields}
      prefix={`${fieldId}.${index}`}
      renderFields={renderFields}
      onPress={actionOnPress && (() => onPress(item._id))}
      columns={columns}
    />
  );

  return (
    <List
      renderItem={renderItem}
      items={value}
      flat={flat}
      style={[styles.main, styles[variant]]}
      columns={columns}
      ListHeaderComponent={<>{header_container}</>}
      ListFooterComponent={<>{footer_container}</>}
      emptyState={emptyState_container}
      contentContainerStyle={styles.container}
    />
  );
}
